import { OUTCOME_CONFIG } from '../types/assessmentHistory.types';
import type { OutcomeKey } from '../types/assessmentHistory.types';

type OutcomeBadgeProps = {
  outcome: string | null;
  size?: 'sm' | 'md';
};

export const OutcomeBadge = ({ outcome, size = 'sm' }: OutcomeBadgeProps) => {
  const key = (outcome ?? 'no_signs') as OutcomeKey;
  const config = OUTCOME_CONFIG[key] ?? OUTCOME_CONFIG.no_signs;

  const sizeClasses = size === 'sm'
    ? 'text-[10px] px-2 py-0.5'
    : 'text-xs px-2.5 py-1';

  return (
    <span
      className={`inline-flex items-center font-bold uppercase tracking-wide rounded-full border ${config.bgClass} ${config.colorClass} ${config.borderClass}/20 ${sizeClasses}`}
    >
      {config.label}
    </span>
  );
};
